// extracted by mini-css-extract-plugin
export default {"containerLoading":"Loading_containerLoading__GMLkb","loading":"Loading_loading__8Y8+o","shimmer":"Loading_shimmer__E4oVv"};